import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { Drawer } from "vaul";
import { Icon } from "@syarahtech/ui";
import { useTranslation } from "@i18n";
import { twMerge } from "tailwind-merge";
import { If } from "@componentsShared/Conditional/If";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import FlowSearchBar from "@/pages/sell-my-car/components/FlowSearchBar";
import FlowZeroResult from "@/pages/sell-my-car/components/FlowZeroResult";
export function DrawerSelect(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    options = _ref.options,
    searchFunction = _ref.searchFunction,
    getDisplayName = _ref.getDisplayName,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "Select an option" : _ref$placeholder,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    error = _ref.error,
    label = _ref.label,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    searchPlaceholder = _ref.searchPlaceholder,
    drawerTitle = _ref.drawerTitle,
    _ref$allowClear = _ref.allowClear,
    allowClear = _ref$allowClear === void 0 ? true : _ref$allowClear,
    renderOption = _ref.renderOption,
    renderTrigger = _ref.renderTrigger,
    _ref$debounceDelay = _ref.debounceDelay,
    debounceDelay = _ref$debounceDelay === void 0 ? 300 : _ref$debounceDelay,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? 50 : _ref$limit,
    _ref$haveTrigger = _ref.haveTrigger,
    haveTrigger = _ref$haveTrigger === void 0 ? true : _ref$haveTrigger,
    id = _ref.id;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var _useState2 = useState([]),
    searchResults = _useState2[0],
    setSearchResults = _useState2[1];
  var _useState3 = useState(""),
    searchTerm = _useState3[0],
    setSearchTerm = _useState3[1];
  var handleSelectOption = function handleSelectOption(option) {
    onChange(option);
    setIsOpen(false);
  };
  var handleClear = function handleClear() {
    onChange(null);
    setIsOpen(false);
  };
  var handleClose = function handleClose() {
    setIsOpen(false);
  };
  var handleSearchResults = function handleSearchResults(results) {
    setSearchResults(results);
  };
  var displayValue = value ? getDisplayName(value) : placeholder;
  var title = drawerTitle || label || "Select";
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: className
  }, label && /*#__PURE__*/React.createElement("label", {
    className: "block text-sm font-medium mb-1"
  }, label), /*#__PURE__*/React.createElement(Conditional, {
    condition: renderTrigger !== undefined
  }, /*#__PURE__*/React.createElement(Then, null, renderTrigger === null || renderTrigger === void 0 ? void 0 : renderTrigger({
    displayValue: displayValue,
    value: value,
    openDrawer: function openDrawer() {
      return !disabled && setIsOpen(true);
    },
    disabled: disabled,
    placeholder: placeholder
  })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(If, {
    condition: haveTrigger
  }, /*#__PURE__*/React.createElement("button", {
    id: id ? "".concat(id, "-trigger") : undefined,
    type: "button",
    onClick: function onClick() {
      return !disabled && setIsOpen(true);
    },
    disabled: disabled,
    className: twMerge("outline-none w-full  p-3 border rounded-lg text-start flex justify-between items-center border-gray-echo border-solid bg-white cursor-pointer",
    // error && "border-red-500",
    disabled && "bg-gray-100 cursor-not-allowed")
  }, /*#__PURE__*/React.createElement("span", {
    className: value ? "text-black-primary" : "text-gray-400"
  }, displayValue), /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--keyboard-arrow-down-rounded",
    className: "text-gray-400",
    width: 5,
    height: 5
  }))))), /*#__PURE__*/React.createElement(If, {
    condition: !!error
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-xs text-[#F22C2C] mt-1 block"
  }, error))), /*#__PURE__*/React.createElement(Drawer.Root, {
    open: isOpen,
    onOpenChange: setIsOpen,
    onClose: handleClose,
    snapPoints: [1],
    closeThreshold: 0.65
  }, /*#__PURE__*/React.createElement(Drawer.Portal, null, /*#__PURE__*/React.createElement(Drawer.Overlay, {
    className: "fixed inset-0 bg-black/40 z-[9998]"
  }), /*#__PURE__*/React.createElement(Drawer.Content, {
    className: "bg-white flex flex-col rounded-t-[10px] h-full mt-24 fixed bottom-0 left-0 right-0 z-[9999]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4 bg-white rounded-t-[10px] flex-1 flex flex-col overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mx-auto w-12 h-1.5 flex-shrink-0 rounded-full bg-gray-300 mb-4"
  }), /*#__PURE__*/React.createElement(Drawer.Title, {
    className: "font-bold text-lg mb-4 text-black-primary"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "mb-4 flex-shrink-0"
  }, /*#__PURE__*/React.createElement(FlowSearchBar, {
    options: options,
    searchFunction: searchFunction,
    onSearch: handleSearchResults,
    getItemKey: function getItemKey(option) {
      return option.id;
    },
    placeholder: searchPlaceholder || tShort("sell_trade_v2/search_placeholder", {
      ns: "web_sell_trade"
    }),
    showResults: false,
    id: "drawer-select-search",
    debounceDelay: debounceDelay,
    limit: limit,
    searchTerm: searchTerm,
    onSearchTermChange: setSearchTerm
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 overflow-y-auto"
  }, /*#__PURE__*/React.createElement(Conditional, {
    condition: searchResults.length === 0
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(FlowZeroResult, {
    searchTerm: searchTerm
  })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement("ul", {
    id: id ? "".concat(id, "-options-list") : undefined,
    className: "space-y-2"
  }, searchResults.map(function (option, index) {
    var isSelected = (value === null || value === void 0 ? void 0 : value.id) === option.id;
    return /*#__PURE__*/React.createElement("li", {
      key: option.id
    }, /*#__PURE__*/React.createElement(Conditional, {
      condition: renderOption !== undefined
    }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement("button", {
      id: id ? "".concat(id, "-option-").concat(index) : undefined,
      type: "button",
      onClick: function onClick() {
        return handleSelectOption(option);
      },
      className: "w-full text-left"
    }, renderOption === null || renderOption === void 0 ? void 0 : renderOption(option, isSelected))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement("button", {
      id: id ? "".concat(id, "-option-").concat(index) : undefined,
      type: "button",
      onClick: function onClick() {
        return handleSelectOption(option);
      },
      className: twMerge("w-full p-3 text-start rounded-lg transition-colors text-gray-text text-sm border border-gray-echo border-solid bg-white cursor-pointer flex items-center", isSelected && "bg-blue-50 border border-primary font-medium")
    }, getDisplayName(option)))));
  }))))))))));
}
export default DrawerSelect;